"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workerizeRedux_1 = require("./workerizeRedux");
var applyWorker_1 = require("./applyWorker");
exports.applyWorker = applyWorker_1.applyWorker;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.createWorker = function (reducer) {
    var workerizeRedux = new workerizeRedux_1.WorkerizeRedux();
    workerizeRedux.addWorkerReducer(reducer);
    return workerizeRedux;
};
